import React from "react";
import { createRoot } from "react-dom/client";
import DocListIsland from "./DocListIsland";

const mountNodes = document.querySelectorAll("[data-doc-list-island]");

mountNodes.forEach((mountNode) => {
  if (mountNode.getAttribute("data-react-mounted") === "true") {
    return;
  }

  const rawConfig = mountNode.getAttribute("data-config");

  if (!rawConfig) {
    return;
  }

  const config = JSON.parse(rawConfig);

  createRoot(mountNode).render(<DocListIsland config={config} />);
  mountNode.setAttribute("data-react-mounted", "true");
});
